<template>
  <div class="about">
    <h1>This is an about page</h1>
    <button-link label="home" @click="$router.push({name:'home'})" />
    <button-link label="about" @click="$router.push({name:'about'})" />

    {{ 'locale: ' + $i18n.locale }}
  </div>
</template>

<script>
// import ButtonBlock from '@/components/ButtonBlock.vue'
import ButtonLink from '@/components/ButtonLink.vue'

export default {
  name: 'about',
  components: {
    // ButtonBlock,
    ButtonLink,
  }
}
</script>